import {configureStore} from "@reduxjs/toolkit"
import {rtkQueryErrorLogger} from "./ErrorLogger"
import {mainSplitApi} from "../api"
import {cristalinaApi} from "../pages/SiteVisit/Services/cristalinaApi"
import auth from "../pages/Login/authSlice"
import common from "../pages/Common/commonSlice"
import error500 from "../ErrorBoundary/Error500Slice"
import toast from "../components/Toaster/ToasterSlice"

export const store = configureStore({
    reducer: {
        [mainSplitApi.reducerPath]: mainSplitApi.reducer,
        [cristalinaApi.reducerPath]: cristalinaApi.reducer,
        auth,
        common,
        error500,
        toast
    },
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware({
            serializableCheck: false,
        })
            .concat(mainSplitApi.middleware)
            .concat(cristalinaApi.middleware)
            .concat(rtkQueryErrorLogger),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
